/** Map Lead Insights `hospitalId` (incl. `all`) to staff list API params. */
export function reportHospitalStaffParams(
  hospitalId?: string,
  extra?: { includeInactive?: boolean }
): { hospitalId?: string; allHospitals?: boolean; includeInactive?: boolean } {
  const base = extra?.includeInactive ? { includeInactive: true as const } : {};
  if (!hospitalId || hospitalId === "all") {
    return { ...base, allHospitals: true };
  }
  return { ...base, hospitalId };
}
